export default "__VITE_ASSET__BOGTRytu__"